var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512c141.385 0 256-114.615 256-256S397.385 0 256 0 0 114.615 0 256s114.615 256 256 256Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0v256L74.98 437.02C121.308 483.346 185.308 512 256 512c141.384 0 256-114.616 256-256C512 114.616 256 0 256 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C185.307 0 121.307 28.654 74.98 74.98L256 256h256C512 114.616 397.384 0 256 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.292 256-31.264-14.706 16.649-30.279-33.95 6.495-4.302-34.297-23.648 25.224-23.647-25.224-4.303 34.297-33.95-6.496 16.65 30.28L22.262 256l31.265 14.706-16.65 30.279 33.953-6.494 4.299 34.296 23.648-25.224 23.648 25.224 4.302-34.296 33.948 6.495-16.648-30.279L175.292 256ZM68.274 100.174l10.404 14.543 17.045-5.399-10.618 14.388 10.404 14.543-16.966-5.651-10.617 14.387.133-17.88-16.965-5.652 17.048-5.399.132-17.88ZM68.274 365.016l10.404 14.543 17.045-5.4-10.618 14.389 10.404 14.543-16.966-5.651-10.617 14.387.133-17.88-16.965-5.652 17.048-5.399.132-17.88ZM216.666 232.596l-10.403 14.543-17.046-5.401 10.618 14.389-10.404 14.544 16.966-5.652 10.618 14.387-.134-17.879 16.965-5.652-17.047-5.399-.133-17.88Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.80929744ce3b6fa9e79f5a079d8df8a2.svg";
export { ForwardRef as ReactComponent };